import invert from "lodash/invert";

export const Family = {
  serif: "Nantes, serif",
  sansSerif: "Graphik, sans-serif",
} as const;

export type Family = (typeof Family)[keyof typeof Family];

export const Weight = {
  thin: "100",
  book: "200",
  light: "300",
  medium: "400",
  bold: "700",
} as const;
export type Weight = (typeof Weight)[keyof typeof Weight];

/** @deprecated This is for old fonts. Use Alphabet Soup fonts instead */
export const getFontFamilyWithWeight = (family: Family, weight: Weight) => {
  let fontFamilyBase: string;
  if (family === Family.serif) {
    fontFamilyBase = "Sentinel";
  } else if (family === Family.sansSerif) {
    fontFamilyBase = "GothamSSm";
  } else {
    fontFamilyBase = "Nantes";
  }
  const weightSuffix = invert(Weight)[`${weight}`] ?? "medium";
  return `${fontFamilyBase}-${weightSuffix
    .charAt(0)
    .toUpperCase()}${weightSuffix.slice(1)}, ${family}`;
};
